<template>
	<div v-if="data" @click="select">
		<p class="font-bold mb-2" v-if="data.ttroom_name">{{ data.ttroom_name }}</p>
		<p class="mb-0" v-if="data.ttroom_capacity">
			<b-icon icon="person-fill"></b-icon> {{ data.ttroom_capacity }}
		</p>
	</div>
</template>

<script>
export default {
	props: ["data", "swipedLeftItem"],
	mounted() {
		console.log("data", this.data);
	},
	methods: {
		select: function () {
			this.$emit("selectItem", this.data.id);
		},
	},
};
</script>
